module.exports = __webpack_public_path__ + "static/media/ball-joints.5d3fcb79.svg";